module.exports = __webpack_public_path__ + "img/icon1.b607e14d.png";